import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-patientappointmentsdialog',
  templateUrl: './patientappointmentsdialog.component.html',
  styleUrls: ['./patientappointmentsdialog.component.css']
})
export class PatientappointmentsdialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PatientappointmentsdialogComponent>) { }


  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
